import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { IconComponent } from '@nagel-assests';
import { IconSize } from '@nagel-types';

export type FillOptions = {
  fill: string;
  color: string;
  percentage: number;
}

const defaultClass = 'relative border border-solid border-current text-center py-0.5 px-2';
const defaultContentStyle = 'relative mat-body-1 z-1 whitespace-nowrap overflow-hidden text-ellipsis';

@Component({
    selector: 'app-chip',
    imports: [IconComponent, MatProgressSpinner],
    templateUrl: './chip.component.html',
    styleUrl: './chip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
    content = input<string | number | boolean | undefined>();
    iconNames = input<string[]>([]);
    iconSize = input<IconSize | undefined>();
    fillPercentage = input<number | undefined>();
    prefixLabel = input<string | undefined>();

    className = input<string | undefined>();
    labelClassName = input<string | undefined>();
    iconClassName = input<string | undefined>();

    isLoading = input<boolean>(false);

    readonly getClass = computed(() => {
        return this.className() ? `${defaultClass} ${this.className()}` : defaultClass;
    });

    readonly getContentStyle = computed(() => {
        let result = defaultContentStyle;

        if (this.prefixLabel() || (this.iconNames() && this.iconNames().length)) {
            result += ' pl-[4px]';
        }

        if (this.labelClassName()) {
            result += ` ${this.labelClassName()}`;
        }

        return result;
    });
}